import { render, staticRenderFns } from "./snowman.vue?vue&type=template&id=0fa5c162&"
import script from "./snowman.vue?vue&type=script&lang=js&"
export * from "./snowman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports